import { getRouteConfig, isRouteParamType, type RouteType } from '@/defs/route'
import { getRouteTemplateSegments } from '@/utils/routeUtil'

export const getGalleryKey = (route?: RouteType) => {
  if (!route) return ''

  const slugs = getRouteTemplateSegments(getRouteConfig(route.section).template).flatMap(({ type, value }) =>
    type === 'required' && isRouteParamType(value) ? [route[value]] : [],
  )

  return [route.section, ...slugs].join('/')
}
